import { TransportOrder } from "../../../model/transportorder/transportOrder"
import { ReactElement } from "react"
import { TransportOrderTableRow } from "./TransportOrderTableRow"
import { columnDetailsByColumn, columns } from "./Columns"
import { TransportOrderTableHead } from "./TransportOrderTableHead"
import { SortBy } from "../../../redux/transportorder.slice"

export const TransportOrderTable = (props: {
    transportOrders: TransportOrder[]
    onSortByChanged: (sortBy: SortBy) => void
    onDetailsClicked: (transportOrder: TransportOrder) => void
    onConfirmClicked: (transportOrder: TransportOrder) => Promise<void>
    scrollLoadTriggerTransportOrderId?: string
    onScrollLoadTriggerRowRendered?: (element: HTMLTableRowElement | null) => void
}): ReactElement => {
    return (
        <table
            className={"table table-layout-fixed table-column-overflow-hidden table-bordered table-hover table-head-filled table-sticky tr.extendedRow"}
            data-testid={"OrderOverview_Table"}
        >
            <TransportOrderTableColGroup/>
            <TransportOrderTableHead onSortByChanged={props.onSortByChanged}/>
            <TransportOrderTableBody
                transportOrders={props.transportOrders}
                onDetailsClicked={props.onDetailsClicked}
                onConfirmClicked={props.onConfirmClicked}
                scrollLoadTriggerTransportOrderId={props.scrollLoadTriggerTransportOrderId}
                onScrollLoadTriggerRowRendered={props.onScrollLoadTriggerRowRendered}
            />
        </table>
    )
}

const TransportOrderTableColGroup = (): ReactElement => {
    const cols = columns.map(column => <col key={column} style={columnDetailsByColumn[column]}/>)

    return <colgroup>{cols}</colgroup>
}

const TransportOrderTableBody = (props: {
    transportOrders: TransportOrder[]
    onDetailsClicked: (transportOrder: TransportOrder) => void
    onConfirmClicked: (transportOrder: TransportOrder) => Promise<void>
    scrollLoadTriggerTransportOrderId?: string
    onScrollLoadTriggerRowRendered?: (element: HTMLTableRowElement | null) => void
}): ReactElement => {

    const transportOrderRows = props.transportOrders.map(it =>
        <TransportOrderTableRow
            key={it.id}
            transportOrder={it}
            onDetailsClicked={props.onDetailsClicked}
            onAcceptClicked={props.onConfirmClicked}
            rowRef={it.id === props.scrollLoadTriggerTransportOrderId ? props.onScrollLoadTriggerRowRendered : undefined}
            isScrollLoadTriggerRow={it.id === props.scrollLoadTriggerTransportOrderId}
        />
    )

    return (
        <tbody>
            {transportOrderRows}
        </tbody>
    )
}
